
import { Component, LOCALE_ID, VERSION, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { NotificationService } from 'src/app/core/services/notification.service';
import { CustomerService } from '../customer.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ImageCroppedEvent } from 'ngx-image-cropper';
import { ConfirmationModalComponent } from './confirmation-modal.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-customer-onboarding-form',
  templateUrl: './customer-onboarding-form.component.html',
  styleUrls: ['./customer-onboarding-form.component.css'],
  providers: [
    NgbModalConfig,
    NgbModal,
  ]
})
export class CustomerOnboardingFormComponent {
  imagePath:any=environment.image_path;
  customerOnBoardingForm!: FormGroup;
  addNewOfficersForm!: FormGroup;
  officersDetailsSubmitted: any = false;
  factoryDetailsSubmitted: any = false;
  bankDetailsSubmitted: any = false;
  addNewFactoryForm!: FormGroup;
  addNewBankForm!: FormGroup;
  companyForm!: FormGroup;
  editOfficersForm!: FormGroup;
  editFactoryForm!: FormGroup;
  editBankForm!: FormGroup;
  userId: any
  disableButton: boolean = false; 
  errorMessage: string = ''; 
  croppedImage: any = "";
  profileImageFile: any = null;
  imageChangedEvent: any = "";

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  maxLength = 15;
  editedOfficerIndex: number | null = null;
  selectedBankIndex: number | null = null;
  selectedFactoryIndex: number | null = null;
  fileName: any;
  file: File | null = null;
  selectedFiled: File | null = null;
  fileTypeError: boolean = false; // Flag for tracking file type errors

  constructor(
    private activatedroute: ActivatedRoute,
    config: NgbModalConfig,
    private modalService: NgbModal,
    private notifyService: NotificationService,
    private customerService: CustomerService,
    private route: Router,
  ) {
    config.backdrop = 'static';
    config.keyboard = false;
  }

  onboardingDetails: any = {
    vcompanyName: "",
    email: "",
    phoneNumber: "",
    contactNumber: "",
    website: "",
    faxNumber: "",
    companyAddress: "",

    vProjectAttachment: [
      { vAttachment: "" },
    ],
    companyOfficers: [],
    companyOffices: [],
    companyBankDetails: []
  };

  ngOnInit(): void {

    this.activatedroute.queryParams.subscribe(params => {
      this.userId = params['iUserId'];
    });

    // this.userId = localStorage.getItem("customer_UserId");

    this.customerOnBoardingForm = new FormGroup({
      profileImage: new FormControl(""),
      companyName: new FormControl("", [this.noWhitespaceValidator(), Validators.maxLength(50)]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
      phoneNumber: new FormControl("", [Validators.required]),
      contactNumber: new FormControl(""),
      website: new FormControl("", [Validators.required, this.noWhitespaceValidator(),Validators.pattern(/^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.[a-zA-Z]{2,})(\/[a-zA-Z0-9-]*)*(\?[a-zA-Z0-9=&]*)?(#[a-zA-Z0-9-]*)?$/)]),
      faxNumber: new FormControl("", [Validators.pattern(/^(\+?\d{1,3})?[-. ]?(\(?\d{2,4}\)?)?[-. ]?\d{3,4}[-. ]?\d{3,4}$/)]),
      companyAddress: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(250)]),
      natureOfBusiness: new FormControl("", [Validators.required]),
      companyType: new FormControl("", [Validators.required]),
      years: new FormControl("", [Validators.required, Validators.pattern(/^\d{1,4}$/),Validators.maxLength(4)]),
      gstNumber: new FormControl("", [ Validators.pattern("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$")]),
      panNumber: new FormControl("", [Validators.pattern("^[A-Z]{5}[0-9]{4}[A-Z]{1}$")]),
      creaditTerms: new FormControl("", [Validators.pattern("^[a-zA-Z0-9\\s]+$"),  this.noWhitespaceValidator()]),
    });

    this.addNewOfficersForm = new FormGroup({
      name: new FormControl("", [Validators.required, this.noWhitespaceValidator(),Validators.maxLength(50)]),
      contactNumber: new FormControl("", [Validators.required]),
      designation: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
    });

    this.addNewFactoryForm = new FormGroup({
      firstName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      state: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      contactNumber: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
      faxNumber: new FormControl("", [Validators.required, Validators.pattern(/^(\+?\d{1,3})?[-. ]?(\(?\d{2,4}\)?)?[-. ]?\d{3,4}[-. ]?\d{3,4}$/)]),
      officeAddress: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(250)]),
    });

    this.addNewBankForm = new FormGroup({
      bankName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      branchName: new FormControl("", [Validators.required, this.noWhitespaceValidator(),Validators.maxLength(50)]),
      bankAccountNumber: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$"),  Validators.minLength(6),  Validators.maxLength(16),this.noWhitespaceValidator()]),
      ifscNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/), this.noWhitespaceValidator()]),
      ibanNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/), this.noWhitespaceValidator()]),
      swiftCode: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/), this.noWhitespaceValidator()]),
      bankDocument: new FormControl(null, Validators.required)
    });

    this.editOfficersForm = new FormGroup({
      name: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      contactNumber: new FormControl("", [Validators.required]),
      designation: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
    });

    this.editFactoryForm = new FormGroup({
      firstName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      state: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(30)]),
      contactNumber: new FormControl("", [Validators.required]),
      email: new FormControl("", [Validators.required, Validators.email, this.noWhitespaceValidator()]),
      faxNumber: new FormControl("", [Validators.required, Validators.pattern(/^(\+?\d{1,3})?[-. ]?(\(?\d{2,4}\)?)?[-. ]?\d{3,4}[-. ]?\d{3,4}$/)]),
      officeAddress: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(250)]),
    });

    this.editBankForm = new FormGroup({
      bankName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      branchName: new FormControl("", [Validators.required, this.noWhitespaceValidator(), Validators.maxLength(50)]),
      bankAccountNumber: new FormControl("", [Validators.required, Validators.pattern("^[0-9]*$"),  Validators.minLength(6),  Validators.maxLength(16),this.noWhitespaceValidator()]),
      ifscNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}0[A-Z0-9]{6}$/), this.noWhitespaceValidator()]),
      ibanNumber: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/), this.noWhitespaceValidator()]),
      swiftCode: new FormControl("", [Validators.required, Validators.pattern(/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/), this.noWhitespaceValidator()]),
      bankDocument: new FormControl(null, Validators.required)
    });
  }

  ngOnDestroy(){
    this.modalService.dismissAll();
  }
  
  AddOfficer(modelName: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.addNewOfficersForm.reset();
  }

  EditOfficer(modelName: any, officer: any, index: number) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.editedOfficerIndex = index;

    this.editOfficersForm.patchValue({
      name: officer.vOfficerName,
      contactNumber: officer.vOfficerPhoneNo,
      designation: officer.vOfficerDesignation,
      email: officer.vOfficerEmailId,
    });
  }

  UpdateOfficer() {
    this.editOfficersForm.markAllAsTouched();
    if (this.editOfficersForm.invalid) {
      return;
    }
    const updatedOfficer = {
      vOfficerName: this.editOfficersForm.value.name,
      vOfficerPhoneNo: this.editOfficersForm.value.contactNumber.number,
      vOfficerDesignation: this.editOfficersForm.value.designation,
      vOfficerEmailId: this.editOfficersForm.value.email,
    };
    if (this.editedOfficerIndex !== null) {
      this.onboardingDetails.companyOfficers[this.editedOfficerIndex] = updatedOfficer;
    }
    this.editedOfficerIndex = null;
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Officer Updated Successfully!", "");
  }

  deleteOfficer(index: number) {
    {
      this.onboardingDetails.companyOfficers.splice(index, 1);
      this.notifyService.showSuccess("Officer Deleted Successfully!", "");
    }
  }

  deleteFactory(index: number) {
    {
      this.onboardingDetails.companyOffices.splice(index, 1);
      this.notifyService.showSuccess("Offices Deleted Successfully!", "");
    }
  }

  deleteBank(index: number) {
    {
      this.onboardingDetails.companyBankDetails.splice(index, 1);
      this.notifyService.showSuccess("Bank Details Deleted Successfully!", "");
    }
  }

  AddBank(modelName: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.fileTypeError = false;
    this.fileName = '';
    this.selectedFiled = null;
    this.addNewBankForm.reset();
  }

  EditBank(modelName: any, bank: any, index: number) {
    this.selectedBankIndex = index;
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });

    const cleanedFileName = this.removeFakePath(bank.txChequeFile);

    this.editBankForm.patchValue({
      bankName: bank.vBankName,
      branchName: bank.vBranchName,
      bankAccountNumber: bank.vBankAccNo,
      ifscNumber: bank.vIfscCode,
      ibanNumber: bank.vIbanNo,
      swiftCode: bank.vSwiftCode,
      bankDocument: cleanedFileName,
    });
    this.fileName = cleanedFileName;
}

  updateBankDetails() {
    this.editBankForm.markAllAsTouched();
    if (this.editBankForm.invalid) {
      return;
    }
    const updatedBank = {
      vBankName: this.editBankForm.value.bankName,
      vBranchName: this.editBankForm.value.branchName,
      vBankAccNo: this.editBankForm.value.bankAccountNumber,
      vIfscCode: this.editBankForm.value.ifscNumber,
      vIbanNo: this.editBankForm.value.ibanNumber,
      vSwiftCode: this.editBankForm.value.swiftCode,
      txChequeFile: this.editBankForm.value.bankDocument,
    };

    if (this.selectedBankIndex !== null) {
      this.onboardingDetails.companyBankDetails[this.selectedBankIndex] = updatedBank;

      this.notifyService.showSuccess("Bank details updated successfully!", "");

      this.modalService.dismissAll();
    }
    this.selectedBankIndex = null;
  }



  AddFactory(modelName: any) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });
    this.addNewFactoryForm.reset();
  }

  EditFactory(modelName: any, office: any, index: number) {
    this.modalService.open(modelName, { centered: true, windowClass: 'custom-modal' });

    this.selectedFactoryIndex = index;

    this.editFactoryForm.patchValue({
      firstName: office.vOfficeName,
      state: office.vOfficeState,
      email: office.vOfficeEmailId,
      contactNumber: office.vOfficePhoneNo,
      faxNumber: office.vOfficeFaxNo,
      officeAddress: office.txOfficeAddress,
    });
  }

  updateFactoryDetails() {
    this.editFactoryForm.markAllAsTouched();
    if (this.editFactoryForm.invalid) {
      return;
    }
    const updatedFactory = {
      vOfficeName: this.editFactoryForm.value.firstName,
      vOfficeState: this.editFactoryForm.value.state,
      vOfficeEmailId: this.editFactoryForm.value.email,
      vOfficePhoneNo: this.editFactoryForm.value.contactNumber.number,
      vOfficeFaxNo: this.editFactoryForm.value.faxNumber,
      txOfficeAddress: this.editFactoryForm.value.officeAddress
    };

    if (this.selectedFactoryIndex !== null) {
      this.onboardingDetails.companyOffices[this.selectedFactoryIndex] = updatedFactory;
      this.notifyService.showSuccess("Factory details updated successfully!", "");
      this.modalService.dismissAll();
    }
    this.selectedFactoryIndex = null;
  }


removeFakePath(filePath: string | null | undefined): string {
    if (!filePath) {
        return ''; 
    }
    return filePath.split('\\').pop() || '';
}


  AddNewOfficersOnSubmit() {
    this.officersDetailsSubmitted = true;
    this.addNewOfficersForm.markAllAsTouched();
    if (this.addNewOfficersForm.invalid) {
      return;
    }
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Officer Added Successfully!", "");
    this.onboardingDetails.companyOfficers.push({
      vOfficerName: this.addNewOfficersForm.value.name,
      vOfficerDialCode: this.addNewOfficersForm.value.contactNumber.dialCode, 
      vOfficerCountryCode: this.addNewOfficersForm.value.contactNumber.countryCode,
      vOfficerDesignation: this.addNewOfficersForm.value.designation,
      vOfficerPhoneNo: this.addNewOfficersForm.value.contactNumber.number,
      vOfficerEmailId: this.addNewOfficersForm.value.email
    });
  }

  AddNewFactoryOnSubmit() {
    this.factoryDetailsSubmitted = true;
    this.addNewFactoryForm.markAllAsTouched();
    if (this.addNewFactoryForm.invalid) {
      return;
    }
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Factory Added Successfully!", "");
    this.onboardingDetails.companyOffices.push({
      vOfficeName: this.addNewFactoryForm.value.firstName,
      vOfficeState: this.addNewFactoryForm.value.state,
      vOfficeDialCode: this.addNewFactoryForm.value.contactNumber.dialCode,
      vOfficeCountryCode: this.addNewFactoryForm.value.contactNumber.countryCode,
      vOfficePhoneNo: this.addNewFactoryForm.value.contactNumber.number,
      vOfficeEmailId: this.addNewFactoryForm.value.email,
      vOfficeFaxNo: this.addNewFactoryForm.value.faxNumber,
      txOfficeAddress: this.addNewFactoryForm.value.officeAddress,
    });
    this.addNewFactoryForm.reset();
  }

  AddBankDetailsOnSubmit() {
    this.bankDetailsSubmitted = true;
    this.addNewBankForm.markAllAsTouched();
    if (this.addNewBankForm.invalid) {
      return;
    }
    this.modalService.dismissAll();
    this.notifyService.showSuccess("Bank Details Added Successfully!", "");
    this.onboardingDetails.companyBankDetails.push({
      vBankName: this.addNewBankForm.value.bankName,
      vBranchName: this.addNewBankForm.value.branchName,
      vBankAccNo: this.addNewBankForm.value.bankAccountNumber,
      vIfscCode: this.addNewBankForm.value.ifscNumber,
      vIbanNo: this.addNewBankForm.value.ibanNumber,
      vSwiftCode: this.addNewBankForm.value.swiftCode,
      txChequeFile: this.addNewBankForm.value.bankDocument,
    });
    this.addNewBankForm.reset();
  }
  
 onFileSelected (event: any) {
    const file: File = event.target.files[0];
    if (file) {
        // Check if the file is of type 'application/pdf'
        if (file.type !== 'application/pdf') {
            this.fileTypeError = true;
            this.fileName = '';
            this.selectedFiled = null;
            event.target.value = ''; // Clear the file input for invalid types
        } else {
            this.fileTypeError = false;
            this.fileName = file.name;
            this.selectedFiled = file;

            // Update the form control with the new file name
            this.editBankForm.patchValue({
                bankDocument: this.fileName
            });
        }
    } else {
        this.fileName = ''; 
        this.selectedFiled = null;
    }
}

  
  uploadFile() {
    if (this.file) {
      const formData = new FormData();
      formData.append('vBankAccNo', this.file, this.file.name);
    } else {
      alert('No file selected');
    }
  }

  CustomerOnboardingProcess() {
    this.customerOnBoardingForm.markAllAsTouched();
    if(this.customerOnBoardingForm.invalid){
      return;
    }

    
    let resData = {
      iUserId: this.userId,
      vCompanyName: this.customerOnBoardingForm.value.companyName,
      vCoEmailId: this.customerOnBoardingForm.value.email,
      vCoDialCode: this.customerOnBoardingForm.value.phoneNumber.dialCode,
      vCoCountyCode: this.customerOnBoardingForm.value.phoneNumber.countryCode,
      vCoContactDialCode: this.customerOnBoardingForm.value?.contactNumber
        ? this.customerOnBoardingForm.value.contactNumber.dialCode || ''
        : '',
      vCoContCountryCode: this.customerOnBoardingForm.value?.contactNumber
        ? this.customerOnBoardingForm.value.contactNumber.countryCode || ''
        : '',
      vCoPhoneNo: this.customerOnBoardingForm.value.phoneNumber.number,
      vCoContactNo: this.customerOnBoardingForm.value?.contactNumber
        ? this.customerOnBoardingForm.value.contactNumber.number || ''
        : '',
      txCoWebsiteLink: this.customerOnBoardingForm.value.website,
      vCoFaxNo: this.customerOnBoardingForm.value.faxNumber,
      txCompanyAddress: this.customerOnBoardingForm.value.companyAddress,
      tiBussinessNature: this.customerOnBoardingForm.value.natureOfBusiness,
      tiCompanyType: this.customerOnBoardingForm.value.companyType,
      iEstabllishmentYear: this.customerOnBoardingForm.value.years,
      vCoGstNo: this.customerOnBoardingForm.value.gstNumber,
      vCoPanNo: this.customerOnBoardingForm.value.panNumber,
      vCoCreditTerms: this.customerOnBoardingForm.value.creaditTerms,
      companyOfficers: this.onboardingDetails.companyOfficers,
      companyOffices: this.onboardingDetails.companyOffices,
      companyBankDetails: this.onboardingDetails.companyBankDetails,
      txCoSign: "ascasc"
    };
    

    const formData = new FormData();

    formData.append('json', JSON.stringify(resData));

    if (this.cropImgPreview) {
      const imageBlob = this.dataURItoBlob(this.cropImgPreview);
      formData.append('logo', imageBlob, 'companyLogo.png');
    }

    if (this.selectedFiled) {
      formData.append('vBankAccNo', this.selectedFiled);
    }

    this.customerService.SubmitOnboardingForm(formData).subscribe((result: any) => {
      if (result.code === 200) {
        this.notifyService.showSuccess(result.message, "");
        this.ConfirmationModel({
          message: 'Start your journey as customer by clicking on "PUBLISH" !'
        });
        this.disableButton = true;
      } else {
        this.notifyService.showError(result.message, "");
      }
    }, error => {
      console.error("API Call Failed:", error);
    });
  }

  ConfirmationModel(data: any) {
    const modalRef = this.modalService.open(ConfirmationModalComponent, {
      centered: true,
      windowClass: 'custom-modal',
    });
    modalRef.componentInstance.message = data.message;
  }
  

  dataURItoBlob(dataURI: string) {
    const byteString = atob(dataURI.split(',')[1]);
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }

  currentOfficerIndex: number = -1;
  isEditMode: boolean = false;


  @ViewChild('cropModal', { static: true }) cropModal: any;

  showCroppedContainer = false;
  imgChangeEvt: any = '';
  cropImgPreview: any = "";
  showEditImage = false;
  selectedFile: File | null = null;
  lastCroppedImg :any


  onFileChange(event: any) {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement && inputElement.files && inputElement.files.length > 0) {
      const file = inputElement.files[0];
      const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
      const maxSize = 5 * 1024 * 1024; // 5MB
  
      const control = this.customerOnBoardingForm.get('profileImage');
  
      if (!allowedTypes.includes(file.type)) {
        control?.setErrors({ invalidType: true });
        return; // Stop execution if invalid type
      } else if (file.size > maxSize) {
        control?.setErrors({ fileTooLarge: true });
        return; // Stop execution if file is too large
      } else {
        control?.setErrors(null); // Clear errors if valid
        this.imgChangeEvt = event;
        this.edit();
        this.showEditImage = true;
      }
    } else {
      console.error('File input element is null or no files selected');
    }
  }
  

  async ImageCropped(event: ImageCroppedEvent) {
    this.profileImageFile = null;
    this.croppedImage = event.base64;
    let base64Response = await fetch(this.croppedImage);
    let blob = await base64Response.blob();
    let fileType = blob.type.split("/")[1];
    this.profileImageFile = new File([blob], "file." + fileType);
  }
  CancelCropModel() {
    this.profileImageFile = null;
    this.imageChangedEvent = "";
    this.croppedImage = "";
  }


  openCropModal() {
    this.modalService.open(this.cropModal, { centered: true, size: 'md' });
  }

  public getImageStream(event: any) {
    const inputElement = event.target as HTMLInputElement;
    const file = inputElement?.files?.[0]; // Use optional chaining to safely access files
  
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.cropImgPreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    } else {
      console.error('No file selected or input element is null');
    }
  }
  
  

  public async cropImg(e: ImageCroppedEvent) {
    if (e.blob) {
      try {
        const base64 = await this.blobToBase64(e.blob);
        this.cropImgPreview = base64;
        this.customerOnBoardingForm.patchValue({
          vProfilePhoto: base64 // Update the form control with the base64 string
        });
      } catch (error) {
        console.error('Error converting blob to base64:', error);
      }
    } else {
      console.error('Crop event does not contain blob data');
    }
  }
  
  
  private blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result as string);
      };
      reader.onerror = reject;
    });
  }
  
  
  onCropDone(modal: any) {
    modal.close();
  }

  edit() {
    this.openCropModal();
  }

  imgLoad() {
    // display cropper tool
  }

  initCropper() {
    // init cropper
  }

  imgFailed() {
    this.cropImgPreview='';
    this.croppedImage='';
    console.error('Image failed to load or crop');
  }

  closeCropperModal(){
    this.cropImgPreview='';
    this.croppedImage='';
    this.profileImageFile = null;
    this.imageChangedEvent = "";
    this.croppedImage = "";
  }
  
  hasError(form: FormGroup, controlName: string, errorName: string): boolean {
    const control = form.get(controlName);
    return !!control?.hasError(errorName) && (!!control?.touched);
  }

   noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const isWhitespace = (control.value || '').startsWith(' ');
      return isWhitespace ? { 'whitespace': true } : null;
    };
  }

  redirectToProfile(){
    this.route.navigate(['customer/profile']);
  }
  
}
